module.exports = __webpack_public_path__ + "img/3.85b092b5.svg";